import React from 'react';
import { ProgressCard }    from './ProgressCard';
import { MetricsCard }     from './MetricsCard';
import { ComparisonCard }  from './ComparisonCard';
import { ChecklistCard }   from './ChecklistCard';
import { TimelineCard }    from './TimelineCard';
import { DecisionCard }    from './DecisionCard';
import { StudyCard }       from './StudyCard';
import { ProjectCard }     from './ProjectCard';
import { RecipeCard }      from './RecipeCard';

const MAP = {
  progress:   ProgressCard,
  metrics:    MetricsCard,
  comparison: ComparisonCard,
  checklist:  ChecklistCard,
  timeline:   TimelineCard,
  decision:   DecisionCard,
  study:      StudyCard,
  project:    ProjectCard,
  recipe:     RecipeCard,
};

export function SmartComponentRenderer({ type, data }) {
  const Component = MAP[type];
  if (!Component || !data) return null;
  return <Component {...data} />;
}
